const getters = {
  customeTag: state => state.app.customeTag,
  loginKey: state => state.user.loginKey,
  userInfo: state => state.user.userInfo,
  addRouters: state => state.permission.addRoutes,
  roles: state => state.user.roles,
  staffList: state => state.user.staffList,
  cachedViews: state => state.tagsView.cachedViews
};

export default getters;
